// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

const FileInput = ({ id, name, label, register, validations, error, accept }) => {
  const { t } = useTranslation();

  return (
    <div className="input-section">
      <label className="label is-primary-color" htmlFor={id}>
        {label}
      </label>
      <input
        type="file"
        id={id}
        aria-label={label}
        className={classNames('input', { 'is-danger': error })}
        accept={accept}
        {...register(name, validations)}
      />
      {error && <span className="input-error">{t(error.message)}</span>}
    </div>
  );
};

FileInput.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  register: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  validations: PropTypes.objectOf(PropTypes.any),
  error: PropTypes.shape({ message: PropTypes.string.isRequired }),
  accept: PropTypes.string,
};

FileInput.defaultProps = {
  validations: {},
  error: null,
  accept: '',
};

export default FileInput;
